import React, { useEffect } from "react";
import { useForm, validators, useFormSubmission } from "@hooks";
import { useLocation, useNavigate } from 'react-router-dom';
import { ExclamationCircleIcon } from "@heroicons/react/24/solid";
import classNames from "classnames";
import { useSpinnerContext } from '@contexts';
import { sunboundPayProxy } from '@proxies';
import { helpers } from "@shared";

const ForgotPassword = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { state: { email = "" } } = location
    const initialState = { email, password: `` };
    const { setSpinnerShow } = useSpinnerContext();

    const { setFormState, hasFormError, formError } = useFormSubmission();

    const validations = {
        email: (val) => validators.isValidEmail(val) || { email: `Email is not valid` },
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const submit = async () => {
        setSpinnerShow(true);
        try {
            const { email } = values;
            await sunboundPayProxy.sendPasswordReset(email);
            helpers.navigateNext(location, navigate, undefined, { email });

        } catch (error) {
            setFormState(`Password reset failed. ${error.message}`);
        }
        setSpinnerShow(false);
    };

    const { values, errors, changeHandler, submitHandler } = useForm(initialState, {}, validations, submit);

    return (
        <div className="page-content-wrapper">
            <h1 className="page-header">Forgot Password</h1>
            <span className="page-subheader">Please verify your email below and we will send an email with instructions to reset your password.</span>
            <form method="POST" className="w-11/12" onSubmit={submitHandler} >
                <div className="content-box shadow-sb items-start pb-7">
                    <div className="w-full">
                        <label htmlFor="email" className="font-semibold text-gray-700">Email</label>
                        <div className="relative mt-1 rounded-md shadow-sm">
                            <input type="text" name="email" id="email" className={classNames(`block w-full rounded-md shadow-md focus:outline-none text-gray-600`, { "input-error": errors.email })} value={values.email} onChange={changeHandler} aria-invalid="true" aria-describedby="email-error" />
                            {
                                errors.email &&
                                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                                    <ExclamationCircleIcon className="fill-red-500 h-6" />
                                </div>
                            }
                        </div>
                        {
                            errors.email &&
                            <p className="mt-2 text-sm text-red-600" id="email-error">{errors.email}</p>
                        }
                    </div>
                </div>
                <div className="page-action">
                    <button type="submit" className="btn btn-primary h-14 mt-7 text-lg font-bold rounded-full">Submit</button>
                </div>
                <div className="flex justify-center w-full">
                    <button
                        className="background-transparent underline font-bold  px-3 py-1 text-lg outline-none focus:outline-none mr-1 mb-1"
                        type="button"
                        onClick={() => navigate(`/`)}>
                        Back to login
                    </button>
                </div>
            </form>
        </div>
    );
};

export default ForgotPassword;
